import { Plugin, Context } from '@nuxt/types';

// Hotjar global variable.
// eslint-disable-next-line prettier/prettier, prefer-rest-params
window.hj = window.hj || function() { (hj.q = hj.q || []).push(arguments) };

// Convenience variable.
const hj = window.hj;

const identifyUser = (context: Context): void => {
  // Send through the user's id to Hotjar. This allows us to filter recordings by user id
  // on Hotjar, which means we can see all the different sessions the user has had on our
  // app.
  //
  // The third argument to 'hj' is an object of 'user attributes' (e.g. signed up date,
  // last campaign sent at date). However, we currently don't need to send through any
  // user attributes besides the user's id. Hotjar seems to require some data for this
  // third argument, so an empty object is used for now.
  hj('identify', context.store.state.user.id, {});
};

const hotjar: Plugin = (context: Context, inject) => {
  inject('hotjar', {
    identifyUser: () => identifyUser(context)
  });
};

export default hotjar;
